import { render, staticRenderFns } from "./OrderConfirmationRecordList.vue?vue&type=template&id=4e7db7c5&"
import script from "./OrderConfirmationRecordList.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports